<script lang="ts">export let size = "20";
const height = size;
</script>

<svg
	{height}
	style="fill: currentColor"
	xmlns="http://www.w3.org/2000/svg"
	viewBox="0 0 29.83 28.35"
	><g
		><path
			d="M29.81 9.29c-.19-.95-1.43-1.19-1.96-.37l-.57.88C25.44 4.04 20.08 0 13.99 0 10.15 0 6.56 1.55 3.9 4.35a14.18 14.18 0 0 0-3.89 10.4C.3 22.14 6.24 28.1 13.54 28.34c6.77.23 12.76-4.52 14.14-11.27.12-.61-.26-1.2-.86-1.33-.59-.13-1.18.26-1.31.87-1.16 5.67-6.16 9.65-11.9 9.48-6.04-.19-11.15-5.32-11.4-11.43-.13-3.29 1.03-6.4 3.27-8.76s5.26-3.66 8.5-3.66c4.96 0 9.35 3.19 11.04 7.79l-.59-.4c-.8-.53-1.84.18-1.65 1.14.06.28.22.53.47.69l2.97 1.98c.5.33 1.16.19 1.49-.31l1.95-3.01c.15-.25.21-.54.15-.82Z"
		/><path
			d="M13.99 5.9c-4.51 0-8.17 3.71-8.17 8.27s3.66 8.27 8.17 8.27 8.18-3.71 8.18-8.27S18.5 5.9 13.99 5.9m2.35 9.39H14c-.61 0-1.1-.5-1.1-1.12V11.7c0-.61.5-1.12 1.1-1.12s1.1.5 1.1 1.12v1.36h1.24c.61 0 1.1.5 1.1 1.12 0 .61-.49 1.12-1.1 1.12Z"
		/></g
	></svg
>
